<template>
  <div>
    <div v-if="loading || !formLoaded">
      <span class="spinner"></span>
    </div>
    <div v-if="!loading && formLoaded">
      <b-form
        @submit.stop.prevent="onSubmit"
        :class="{
          'p-3 box-shadow2 rounded': !isDarkMode,
          'dark-div p-3 box-shadow2 rounded': isDarkMode
        }"
      >
        <b-row>
          <b-col sm="12" lg="6">
            <b-form-group id="group-title" label-for="input-title">
              <template v-slot:label>
                Title
                <span class="text-danger">*</span>
              </template>

              <b-form-input
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                id="input-title"
                type="text"
                v-model="form.title"
                placeholder="Enter Document Title"
                :state="$v.form.title.$dirty ? !$v.form.title.$error : null"
              ></b-form-input>

              <b-form-invalid-feedback id="input-title-invalid">Please enter document title.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="group-description" label-for="input-description">
              <template v-slot:label>
                Description
                <span class="text-danger">*</span>
              </template>

              <b-form-input
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                id="input-description"
                type="text"
                v-model="form.description"
                placeholder="Enter Document Description"
                :state="$v.form.description.$dirty ? !$v.form.description.$error : null"
              ></b-form-input>

              <b-form-invalid-feedback id="input-name-invalid"
                >Please enter document description.</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="6">
            <b-form-group id="group-product" label-for="input-product">
              <template v-slot:label>
                Active
                <span class="text-danger">*</span>
              </template>

              <multiselect
                :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
                id="input-status"
                placeholder="Select Active Type"
                v-model="form.active"
                :options="['True', 'False']"
                :state="$v.form.active.$dirty ? !$v.form.active.$error : null"
              >
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="group-product" label-for="input-product">
              <template v-slot:label>
                Document Type
                <span class="text-danger">*</span>
              </template>

              <multiselect
                :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
                id="input-status"
                placeholder="Select Document Type"
                v-model="form.documentType"
                :options="documentTypeOptions"
                :state="$v.form.documentType.$dirty ? !$v.form.documentType.$error : null"
              ></multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="6">
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Select Date
                <span class="text-danger">*</span>
              </template>
              <b-row>
                <b-col>
                  <b-input-group class="box-shadow2 mb-2">
                    <b-input-group-append>
                      <b-form-datepicker
                        button-only
                        id="start-datepicker"
                        placeholder="Start Date"
                        :min="minDate"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        v-model="form.startDate"
                        class="box-shadow3"
                      ></b-form-datepicker>
                    </b-input-group-append>
                    <b-form-input
                      id="example-input"
                      v-model="form.startDate"
                      type="text"
                      placeholder="Start Date"
                      autocomplete="off"
                      :class="{
                        '': !isDarkMode,
                        'bg-dark text-light placeholder-light': isDarkMode
                      }"
                      disabled
                    ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col>
                  <b-input-group class="box-shadow2 mb-2">
                    <b-input-group-append>
                      <b-form-datepicker
                        button-only
                        id="end-datepicker"
                        placeholder="End Date"
                        :min="minDate"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        v-model="form.endDate"
                        class="box-shadow3"
                      ></b-form-datepicker>
                    </b-input-group-append>
                    <b-form-input
                      id="example-input"
                      v-model="form.endDate"
                      type="text"
                      placeholder="End Date"
                      autocomplete="off"
                      :class="{
                        '': !isDarkMode,
                        'bg-dark text-light placeholder-light': isDarkMode
                      }"
                      disabled
                    ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <!-- Store Ids field shown in same row for SSM users -->
          <b-col v-if="isStoreSalesManager" sm="12" lg="6">
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Store Ids
                <span class="text-danger"></span>
              </template>
              <multiselect
                v-model="storeids"
                ref="multiselect"
                tag-placeholder="Add this as new tag"
                placeholder="Select Store Ids"
                label="text"
                track-by="value"
                :options="stores"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
                :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
              ></multiselect>
              <b-form-text id="input-role-help"
                >Note: The first selected store id will be the primary store id.</b-form-text
              >
            </b-form-group>
          </b-col>
          <!-- Store Format field hidden for SSM users -->
          <b-col v-if="!isStoreSalesManager">
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Store Format
                <span class="text-danger"></span>
              </template>

              <multiselect
                ref="multiselect"
                tag-placeholder="Add this as new tag"
                track-by="value"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
                v-model="form.formats"
                placeholder="Select Store Format"
                label="text"
                :options="formats"
                :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
              >
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Region and Cluster fields hidden for SSM users -->
        <b-row v-if="!isStoreSalesManager">
          <b-col sm="12" lg="6">
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Region Ids
                <span class="text-danger"></span>
              </template>

              <multiselect
                ref="multiselect"
                tag-placeholder="Add this as new tag"
                track-by="value"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
                v-model="regionids"
                placeholder="Select region Ids"
                label="text"
                :options="regions"
                :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
              >
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Cluster Ids
                <span class="text-danger"></span>
              </template>
              <multiselect
                ref="multiselect"
                tag-placeholder="Add this as new tag"
                track-by="value"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
                v-model="clusterids"
                placeholder="Select Cluster Ids"
                label="text"
                :options="clusters"
                :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
              >
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Store Ids field shown separately for non-SSM users -->
        <b-form-group v-if="!isStoreSalesManager" id="group-products" label-for="input-products">
          <template v-slot:label>
            Store Ids
            <span class="text-danger"></span>
          </template>
          <multiselect
            v-model="storeids"
            ref="multiselect"
            tag-placeholder="Add this as new tag"
            placeholder="Select Store Ids"
            label="text"
            track-by="value"
            :options="stores"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
            :class="{
              'box-shadow3': !isDarkMode,
              darkMode: isDarkMode
            }"
          ></multiselect>
          <b-form-text id="input-role-help"
            >Note: The first selected store id will be the primary store id.</b-form-text
          >
          <div class="mt-2">
            <b-form-group id="group-text-area" label-for="input-text-area">
              <template v-slot:label> Add Remarks </template>

              <div v-for="(info, index) in form.remarks" :key="index" class="mb-3 d-flex align-items-center">
                <b-form-textarea
                  :id="'input-text-area-' + index"
                  v-model="info.text"
                  placeholder="Enter any remarks here"
                  class="flex-grow-1 textarea-height"
                  :class="{
                    'box-shadow3 bg-light text-dark': !isDarkMode,
                    'bg-dark text-light placeholder-light': isDarkMode
                  }"
                  style="height: 60px"
                ></b-form-textarea>
                <b-button
                  v-if="index !== 0 || form.remarks.length > 1"
                  variant="danger"
                  class="ml-2"
                  @click="removeKeyPoint(index)"
                >
                  Delete
                </b-button>
              </div>
              <b-button variant="primary" @click="addKeyPoint">Add More Remark</b-button>
            </b-form-group>
          </div>

          <b-button class="box-shadow2" @click="uploadStores" :variant="isDarkMode ? 'outline-success' : 'success'"
            ><font-awesome-icon :icon="['fas', 'upload']" class="mr-1" />Upload Stores</b-button
          >
        </b-form-group>

        <b-form-group id="group-products" label-for="input-products">
          <template v-slot:label>
            {{ isStoreSalesManager ? 'LIQUOR GRN Document' : 'Upload Document' }}
            <span class="text-danger">*</span>
          </template>
          <input type="file" @change="uploadFile($event)" :accept="isStoreSalesManager ? 'application/pdf' : '*'" />
          <b-form-text v-if="isStoreSalesManager" class="text-muted"> Only PDF files are allowed </b-form-text>
        </b-form-group>
        <template v-if="fileError">
          <b-row class="mb-2">
            <b-col class="text-danger message-col">{{ fileError }}</b-col>
          </b-row>
        </template>
        <!-- <video class="videoPlayer" id="video-preview" controls v-show="file != ''" /> -->

        <template v-if="storeIdError">
          <b-row class="mb-2">
            <b-col class="text-danger message-col">{{ storeIdError }}</b-col>
          </b-row>
        </template>
        <template v-if="regionIdError">
          <b-row class="mb-2">
            <b-col class="text-danger message-col">{{ regionIdError }}</b-col>
          </b-row>
        </template>
        <template v-if="clusterIdError">
          <b-row class="mb-2">
            <b-col class="text-danger message-col">{{ clusterIdError }}</b-col>
          </b-row>
        </template>

        <b-form-group>
          <b-row class="mt-2">
            <b-col class="text-right">
              <b-button
                class="box-shadow2"
                type="submit"
                size="sm"
                :variant="isDarkMode ? 'outline-success' : 'success'"
                :disabled="loading"
              >
                <span class="spinner spinner-white" v-if="loading"></span>
                <font-awesome-icon :icon="['fas', 'save']" class="mr-1" />Save
              </b-button>
              <b-button
                class="ml-2 box-shadow2"
                size="sm"
                :variant="isDarkMode ? 'outline-warning' : 'warning'"
                :to="{ path: `/document-share` }"
              >
                <font-awesome-icon :icon="['fas', 'long-arrow-alt-left']" class="mr-1" />Back to list
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
import csv from 'csvtojson';
import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { mapGetters, mapState, mapActions } from 'vuex';
import configService from '@/services/configService';
import router from '@/router';
import Multiselect from 'vue-multiselect';

export default {
  name: 'VideoFormBox',
  components: {
    Multiselect
  },
  props: {
    listUrl: String,
    formType: String,
    documentType: String
  },
  metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        }
      ]
    };
  },
  data() {
    return {
      inputs: [
        {
          name: ''
        }
      ],
      title: '',
      description: '',
      documentUrl: '',
      file: [],
      formLoaded: true,
      regions: [],
      clusters: [],
      formats: [],
      stores: [],
      storeids: [],
      clusterids: [],
      regionids: [],
      selectedFile: null,
      form: {
        title: null,
        description: null,
        active: 'True',
        documentType: 'SOP',
        startDate: null,
        endDate: null,
        storeids: [],
        regionids: [],
        formats: [],
        clusterids: [],
        remarks: [{ id: Date.now(), text: '' }],
        file: ''
      },
      storeIdError: null,
      clusterIdError: null,
      regionIdError: null,
      fileError: null,
      dateTimeFormat: configService.get('format').pickerDateTime,
      minDate: moment().format('YYYY-MM-DD'),
      timeStamp: ''
    };
  },
  validations() {
    const formValidation = {
      description: {
        required
      },
      active: {
        required
      },
      title: {
        required
      },
      documentType: {
        required
      }
    };

    if (this.formType === 'new') {
      formValidation.description.required = required;
      formValidation.title.required = required;
      formValidation.active.required = required;
      formValidation.documentType.required = required;
    }

    return { form: formValidation };
  },
  mounted() {
    this.getStoreByUser();
    this.listStore({ router });
    this.listCluster({ router, query: { type: 'cluster' } });
    this.listRegion({ router, query: { type: 'region' } });
    this.listFormat({ router, query: { type: 'format' } });
    this.$nextTick(async () => {
      if (this.formType === 'new') {
        // Set default document type for SSM users
        if (this.isStoreSalesManager) {
          this.form.documentType = 'LIQUOR_GRN';
        }
        this.formLoaded = true;
        this.$v.$touch(); // Set initial validation
        this.$v.$reset(); // Reset $dirty
      }
    });
  },
  computed: {
    metaDescription() {
      return this.formType === 'new' ? 'Add new Document' : 'Update Document';
    },
    ...mapGetters('alert', ['errorMessages']),
    ...mapState('document', ['loading', 'document']),
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('store', ['storeList', 'regionList', 'clusterList', 'formatList']),
    ...mapState('auth', {
      authUser: 'user'
    }),
    ...mapState('cstSubmission', ['store']),
    isAdmin() {
      if (!this.authUser || !this.authUser.roles) return false;
      const newUser = this.authUser.roles.map(role => role.name);
      const admin = newUser.filter(role => role.includes('ADMIN') || role.includes('SUB_ADMIN'));
      return admin.length > 0;
    },
    isStoreSalesManager() {
      if (!this.authUser || !this.authUser.roles) {
        return false;
      }
      const storeSalesManager = this.authUser.roles.filter(
        role => role && role.name && role.name.includes('STORE_SALES_MANAGER')
      );
      return storeSalesManager.length > 0;
    },
    documentTypeOptions() {
      if (this.isStoreSalesManager) {
        return ['LIQUOR_GRN'];
      }
      return ['SOP', 'PLANOGRAM', 'LAYOUT', 'C&B'];
    }
  },
  methods: {
    ...mapActions('document', ['postOne', 'patchOne', 'uploadDocument', 'sendNotifications']),
    ...mapActions('store', ['listStore', 'listRegion', 'listCluster', 'listFormat']),
    ...mapActions('cstSubmission', ['getStoreByUser']),
    // previewVideo() {
    //   const video = document.getElementById('video-preview');
    //   const reader = new FileReader();

    //   reader.readAsDataURL(this.file);
    //   reader.addEventListener('load', function () {
    //     video.src = reader.result;
    //   });
    // },

    uploadFile(event) {
      this.fileError = null;
      const selectedFile = event.target.files[0];

      // Validate PDF file type for SSM users
      if (this.isStoreSalesManager && selectedFile) {
        const fileType = selectedFile.type;
        const fileName = selectedFile.name.toLowerCase();
        const isValidPdf = fileType === 'application/pdf' || fileName.endsWith('.pdf');

        if (!isValidPdf) {
          this.fileError = 'Only PDF files are allowed for GRN Document upload.';
          event.target.value = ''; // Clear the file input
          this.file = null;
          return;
        }
      }

      this.file = selectedFile;
      this.timeStamp = new Date().getTime();
      // this.previewVideo();
    },

    createCsv() {
      const csv = `Store Id\n`;
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'sampleFile.csv';
      anchor.click();
    },
    async uploadStores() {
      await Vue.swal({
        title: 'Upload file for Stores..',
        input: 'file',
        inputAttributes: {
          'aria-label': 'Upload your Store file in csv format'
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Upload',
        denyButtonText: 'Download Sample',
        denyButtonColor: '#3a4',
        showCancelButton: true,
        showDenyButton: true,
        cancelButtonText: 'Close',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      }).then(result => {
        if (result.isDenied) {
          this.createCsv();
        }
        if (result.value) {
          const reader = new FileReader();
          reader.onload = async () => {
            csv({
              noheader: true,
              output: 'csv'
            })
              .fromString(reader.result)
              .then(csvRow => {
                const inputs = csvRow.slice(1, csvRow.length).map(item => {
                  if (item[0].length !== 4) {
                    Vue.swal({
                      title: 'Access Denied',
                      text: `Store Id ${item[0].charAt(0).toUpperCase() + item[0].slice(1)} must be 4 digits`,
                      type: 'error',
                      confirmButtonText: 'Ok',
                      background: this.isDarkMode ? '#464d54' : '#ffffff',
                      customClass: {
                        title: this.isDarkMode ? 'text-light' : 'text-dark',
                        content: this.isDarkMode ? 'text-light' : 'text-dark'
                      }
                    });
                    return null;
                  }
                  const inUppercase = item[0].toUpperCase();
                  const compareStoreIdFromDatabse = this.newStoreList.filter(store => store.storeid === inUppercase);
                  if (compareStoreIdFromDatabse.length === 0) {
                    Vue.swal({
                      title: 'Access Denied',
                      text: `Store id ${
                        item[0].charAt(0).toUpperCase() + item[0].slice(1)
                      } is not found in database! Please enter correct store id.`,
                      type: 'error',
                      confirmButtonText: 'Ok',
                      background: this.isDarkMode ? '#464d54' : '#ffffff',
                      customClass: {
                        title: this.isDarkMode ? 'text-light' : 'text-dark',
                        content: this.isDarkMode ? 'text-light' : 'text-dark'
                      }
                    });
                    return null;
                  }
                  return {
                    value: item[0].charAt(0).toUpperCase() + item[0].slice(1),
                    text: item[0].charAt(0).toUpperCase() + item[0].slice(1)
                  };
                });
                const uniqueStoreId = new Set(inputs.map(input => input.value));
                const getDuplicateValue = [...uniqueStoreId].filter(
                  item => inputs.filter(input => input.value === item).length > 1
                );
                if (getDuplicateValue.length > 0) {
                  Vue.swal({
                    title: 'Access Denied',
                    text: `Store id ${getDuplicateValue[0]} is duplicate in sample file!`,
                    type: 'error',
                    confirmButtonText: 'Ok',
                    background: this.isDarkMode ? '#464d54' : '#ffffff',
                    customClass: {
                      title: this.isDarkMode ? 'text-light' : 'text-dark',
                      content: this.isDarkMode ? 'text-light' : 'text-dark'
                    }
                  });
                  return null;
                }
                this.abc = inputs.map(store => ({
                  value: store.value,
                  text: store.value
                }));
                const newAddingStore = this.abc.map(store => store.value);
                const foundExistStore = this.storeids.filter(store => newAddingStore.includes(store.value));
                if (foundExistStore.length > 0) {
                  Vue.swal({
                    title: 'Access Denied',
                    text: `Store id ${foundExistStore[0].value} is already there!`,
                    type: 'error',
                    confirmButtonText: 'Ok',
                    background: this.isDarkMode ? '#464d54' : '#ffffff',
                    customClass: {
                      title: this.isDarkMode ? 'text-light' : 'text-dark',
                      content: this.isDarkMode ? 'text-light' : 'text-dark'
                    }
                  });
                  return null;
                }
                this.storeids = [...this.storeids, ...this.abc];
              });
          };
          reader.readAsBinaryString(result.value);
        }
      });
    },

    async onSubmit() {
      this.storeIdError = null;
      this.fileError = null;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      const storeids = this.storeids && this.storeids.length > 0 ? this.storeids.map(({ value }) => value) : [];
      const { documentUrl } = this;
      const documentType = this.form.documentType ? this.form.documentType.toLowerCase() : 'sop';

      if (this.formType === 'new' && !this.file.name) {
        this.$swal({
          title: 'Error',
          text: 'Please select a document file before submitting.',
          icon: 'error'
        });
        return false;
      }
      if (this.file) {
        await this.uploadDocument({
          file: this.file,
          fileName: `${storeids?.[0]}-${this.timeStamp}-${this.file?.name}`
        });
      }
      const document = {
        title: this.form.title,
        description: this.form.description,
        active: this.form.active === 'True',
        documentType: documentType.toUpperCase(),
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        storeids,
        documentName: `${storeids?.[0]}-${this.timeStamp}-${this.file?.name}`,
        clusters: [],
        regions: [],
        formats: [],
        documentUrl: documentUrl || '',
        remarks: this.form?.remarks[0]?.text?.trim() !== '' ? this.form.remarks : [],
        uploadType: 'single_upload'
      };

      const uniqueSets = {
        layout: { storeids: new Set() },
        planogram: { storeids: new Set() },
        sop: { storeids: new Set() },
        liquor_grn: { storeids: new Set() },
        'c&b': { storeids: new Set() }
      };

      if (uniqueSets[documentType] && Array.isArray(document.storeids) && document.storeids.length > 0) {
        document.storeids.forEach(storeid => {
          if (storeid) {
            uniqueSets[documentType].storeids.add(storeid);
          }
        });
      }

      const params = {
        layout: {
          storeids: Array.from(uniqueSets.layout.storeids)
        },
        planogram: {
          storeids: Array.from(uniqueSets.planogram.storeids)
        },
        sop: {
          storeids: Array.from(uniqueSets.sop.storeids)
        },
        liquor_grn: {
          storeids: Array.from(uniqueSets.liquor_grn.storeids)
        },
        'c&b': {
          storeids: Array.from(uniqueSets['c&b'].storeids)
        }
      };
      this.sendNotifications({ params, router });
      if (this.formType === 'new') {
        this.$emit('add', { document });
      } else {
        this.$emit('edit', { document });
      }

      return false;
    },
    addKeyPoint() {
      this.form.remarks.push({ id: Date.now(), text: '' });
    },
    removeKeyPoint(index) {
      this.form.remarks.splice(index, 1);
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
      setTimeout(() => {
        this.$refs.multiselect.$refs.search.focus();
      }, 100);
    }
  },
  watch: {
    isStoreSalesManager(newVal) {
      // Set default document type for SSM users when creating new form
      if (newVal && this.formType === 'new' && this.form.documentType !== 'LIQUOR_GRN') {
        this.form.documentType = 'LIQUOR_GRN';
      }
    },
    document(newValue) {
      if (!this.document.id) {
        return;
      }
      // Loaded Video Deatils, assign to form
      this.form.title = newValue.title;
      this.form.description = newValue.description;
      this.form.active = newValue.active;
      this.form.documentType = newValue.documentType;
      this.documentUrl = newValue.documentUrl;
      this.form.startDate = moment(newValue.startDate).format('YYYY-MM-DD');
      this.form.endDate = moment(newValue.endDate).format('YYYY-MM-DD');
      this.storeids = newValue.storeids.map(store => ({ value: store, text: store }));
      this.regionids = newValue.regions.map(region => ({ value: region, text: region }));
      this.clusterids = newValue.clusters.map(cluster => ({ text: cluster, value: cluster }));
      this.form.formats = newValue.formats.map(format => ({ text: format, value: format }));
      this.form.remarks = newValue.remarks;

      this.formLoaded = true;
      this.$v.$touch(); // Set initial validation
      this.$v.$reset(); // Reset $dirty
    },
    clusterList(newValue) {
      this.clusters = newValue;
    },
    regionList(newValue) {
      this.regions = newValue;
    },
    formatList(newValue) {
      this.formats = newValue;
    },
    storeList(newValue) {
      let comparingStores = [];
      comparingStores = newValue.map(store => ({
        storeid: store.storeid
      }));
      this.newStoreList = comparingStores;

      // Filter stores based on user's storeids if not admin
      if (this.isAdmin) {
        this.stores = newValue.map(store => ({ text: store.storeid, value: store.storeid }));
      } else {
        // Only show stores that match user's storeids
        if (this.authUser && this.authUser.storeids && this.authUser.storeids.length > 0) {
          this.stores = newValue
            .filter(store => this.authUser.storeids.includes(store.storeid))
            .map(store => ({ text: store.storeid, value: store.storeid }));

          // Set default storeid if form is new and no storeid is selected yet
          if (this.formType === 'new' && this.storeids.length === 0 && this.stores.length > 0) {
            this.storeids = [{ text: this.stores[0].value, value: this.stores[0].value }];
          }
        } else {
          this.stores = [];
        }
      }
    },
    authUser(newValue) {
      // Re-filter stores when user loads, if storeList is already available
      if (newValue && this.storeList && this.storeList.length > 0) {
        if (this.isAdmin) {
          this.stores = this.storeList.map(store => ({ text: store.storeid, value: store.storeid }));
        } else if (newValue.storeids && newValue.storeids.length > 0) {
          this.stores = this.storeList
            .filter(store => newValue.storeids.includes(store.storeid))
            .map(store => ({ text: store.storeid, value: store.storeid }));

          // Set default storeid if form is new and no storeid is selected yet
          if (this.formType === 'new' && this.storeids.length === 0 && this.stores.length > 0) {
            this.storeids = [{ text: this.stores[0].value, value: this.stores[0].value }];
          }
        } else {
          this.stores = [];
        }
      }
    },
    store(newValue) {
      if (newValue && newValue.length > 0) {
        // Map stores from getStoreByUser to the format needed for multiselect
        this.stores = newValue.map(store => ({ text: store.storeid, value: store.storeid }));

        // Set default storeid if form is new and no storeid is selected yet
        if (this.formType === 'new' && this.storeids.length === 0 && this.stores.length > 0) {
          this.storeids = [{ text: this.stores[0].value, value: this.stores[0].value }];
        }
      }
    }
  }
};
</script>
<style src="vue-search-select/dist/VueSearchSelect.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.calender {
  display: flex;
  width: auto;
  margin-left: -9px;
  margin-bottom: 0.7rem;
}

.date {
  margin-left: -10px;
}

.upload {
  margin-top: 8px;
}

.videoPlayer {
  width: 25%;
}
</style>
<style scoped>
.textarea-height {
  height: 40px;
  /* Set your desired height here */
}
</style>
